import React from "react";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

const SalesBreakdown = ({ breakdown }) => {
  return (
    <ResponsiveContainer width="100%" height={313}>
      <BarChart width={600} height={300} data={breakdown}>
        <CartesianGrid strokeDasharray="2 2" />
        <XAxis dataKey="date" />
        <YAxis tickFormatter={tick => tick / 100} />

        <Tooltip
          formatter={(value, name, props) => props.payload[`${name}_formatted`]}
        />
        <Legend
          verticalAlign="top"
          align="right"
          iconType="circle"
          wrapperStyle={{ top: 0 }}
        />
        <Bar dataKey="profit" stackId="a" fill="#bab1ff" />
        <Bar dataKey="cost" stackId="a" fill="#8144e5" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SalesBreakdown;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/financialDashboard/SalesBreakdown.js